import { ReactNode } from 'react';

import { RffFormContext } from './_providers';
import { RffFormState } from './types';

type Props = { children: (state: RffFormState) => ReactNode };

export const RffFormConsumer = ({ children }: Props) => {
  return <RffFormContext.Consumer>{children}</RffFormContext.Consumer>;
};
